// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4645":"f8d8f54929018d12","5036":"c0c829b06abcba1a"}[chunkId] + ".js";
};